mutation DeleteNote($input: NoteDeleteInput!) {
  noteDelete(input: $input) {
    deletedEntities {
      id
    }
  }
}
